import InvitationConfirmation from './pages';

export default InvitationConfirmation;
